import { DeviceSettings } from '../../config/DeviceSettings';

import { theme } from '../../theme/theme';

import { useSensorState } from '../../hooks/useSensorState';

import { Icon } from '../common/Icon';
import { ZoneActivityPulse } from '../zone/ZoneActivityPulse';

import { iconWarningCircle } from '../../theme/icons/interface/warning-circle/warning-circle';

export function IndicatorAlarm({ device }) {
  const { hasAlarm, hasOnlyZoneActivityAlarm } = useSensorState({
    deviceId: device.id,
    capabilitiesObj: device.capabilitiesObj,
  });

  if (hasAlarm === false) {
    return null;
  }

  if (
    device.settings[DeviceSettings.ZoneActivityDisabled] === false &&
    hasOnlyZoneActivityAlarm === true
  ) {
    return <ZoneActivityPulse />;
  }

  return <Icon display="block" url={iconWarningCircle} color={theme.color.yellow} size="20px" />;
}
